import { SourcesMenuConfigContext } from '#pplx/frontend/apps/ask/ask-input/ask-input-sources-menu/components/SourcesMenuConfigContext.js';
import { useContext } from 'react';
export function useSourcesMenuConfig() {
    return useContext(SourcesMenuConfigContext);
}
//# sourceMappingURL=SourcesMenuConfigContextSupport.js.map